module.exports = __webpack_public_path__ + "static/media/2S.b821dcd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2S.svg
// module id = 56
// module chunks = 0